import { gql } from "@apollo/client";

export const GET_GSC_ANALYTICS_OVERVIEW = gql`
  query GetGscAnalyticsOverview($site_url: String!, $start_date: String, $end_date: String, $email: String) {
    analyticsOverview(site_url: $site_url, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_TRENDS = gql`
  query GetGscAnalyticsTrends($site_url: String!, $start_date: String, $end_date: String, $email: String) {
    analyticsTrends(site_url: $site_url, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_TOP_PAGES = gql`
  query GetGscAnalyticsTopPages($site_url: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    analyticsTopPages(site_url: $site_url, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_TOP_QUERIES = gql`
  query GetGscAnalyticsTopQueries($site_url: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    analyticsTopQueries(site_url: $site_url, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_DEVICES = gql`
  query GetGscAnalyticsDevices($site_url: String!, $start_date: String, $end_date: String, $email: String) {
    analyticsDevices(site_url: $site_url, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_COUNTRIES = gql`
  query GetGscAnalyticsCountries($site_url: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    analyticsCountries(site_url: $site_url, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_SEARCH_APPEARANCE = gql`
  query GetGscAnalyticsSearchAppearance($site_url: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    analyticsSearchAppearance(site_url: $site_url, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GSC_ANALYTICS_DASHBOARD = gql`
  query GetGscAnalyticsDashboard($site_url: String!, $start_date: String, $end_date: String, $email: String) {
    analyticsDashboard(site_url: $site_url, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;
